import { financeStatus } from "constants/global";

const FinanceBadge = ({ badgeType = "Disbursed", text }) => {
    const textToShow = text || financeStatus[badgeType]?.text;
    return (
        <div
            style={{
          border: financeStatus[badgeType]?.borderColor ? "1px solid" : '',
                borderColor: financeStatus[badgeType]?.borderColor,
                backgroundColor: financeStatus[badgeType]?.bgColor,
                color: financeStatus[badgeType]?.textColor,
            }}
        className="px-2 py-[1px] font-[350] text-xs inline-flex rounded-2xl h-[24px] items-center justify-center"
        >
            {textToShow}
        </div>
    );
};

export default FinanceBadge;